export const CUSTOMER_UIBLOCKS_CATEGORY_ID =
  "086c1331-b667-4c2e-ad9e-dced71eb74d7";
export const CUSTOMER_NAME = "Square Engineering";
